import React, { useState, useEffect } from 'react';
import { FormGroup } from 'reactstrap';
import '../containers/epikBoxes/BoxList/epikBoxes.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddLocationModal from './AddLocationModal';
import LocationAutocomplete from './LocationAutocomplete';

const LocationDetails = ({
  locations,
  fetchingLocations,
  createNewLocation,
  onRemoveLocation,
  updateLocation,
  selectLocation,
  defaultSelected,
  onRemoveConfirm,
  boxesLocation,
  disabledAdmin,
  selectedLocationObj,
}) => {
  const token = localStorage.getItem('jwtToken');
  const [dropdownCompany, setCompany] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [formData, setFormData] = useState('');
  const [addLocationModal, setAddLocationModal] = useState(false);
  const [allLocations, setAllLocations] = useState([]);

  const toggle = () => {
    // setCompany(!dropdownCompany);
  };
  const locationModal = () => setAddLocationModal(!addLocationModal);

  const onSelectLocationChange = async location => {
    const { suggestion } = location;
    if (suggestion !== null) {
      setSelectedLocation(suggestion.locationName);
      selectLocation(suggestion);
      setCompany(false);
    }
  };

  const onAddNewLocation = () => {
    setAddLocationModal(!addLocationModal);
  };

  useEffect(() => {
    if (locations && locations.length) {
      setAllLocations(locations);
    }
  }, [locations]);

  useEffect(() => {
    if (defaultSelected && defaultSelected.locationName) {
      setSelectedLocation(defaultSelected.locationName);
    }
  }, [defaultSelected]);

  const addNewLocation = async e => {
    console.log('locationName', e?.name);
    setSelectedLocation(e?.name);
    if (formData === '') {
      await createNewLocation({ address: e });
    } else {
      await updateLocation({ address: e });
    }
    locationModal();
    setFormData('');
  };

  useEffect(() => {
    if (onRemoveConfirm) {
      setSelectedLocation('');
      setFormData('');
    }
  }, [onRemoveConfirm]);

  return (
    <>
      <FormGroup className="company-details-drop">
        <LocationAutocomplete
          fetchingLocations={fetchingLocations}
          selectedLocationObj={selectedLocationObj}
          disabledAdmin={!locations.length}
          boxesLocation={!boxesLocation}
          placeholder={`${locations.length ? 'Select Location' : 'No location found'}`}
          searchTerm={selectedLocation}
          locations={locations && locations.length ? locations : []}
          onChange={onSelectLocationChange}
          onRemoveLocation={e => {
            onRemoveLocation(e);
          }}
          onAddNewLocation={e => {
            // setSelectedLocation('');
            setFormData(e);
            onAddNewLocation();
          }}
        />
        {!boxesLocation && !disabledAdmin && (
          <div onClick={onAddNewLocation} style={{ cursor: 'pointer' }}>
            <FontAwesomeIcon
              icon="plus"
              size="sm"
              color="#29a4ff"
              style={{ marginRight: '0.3rem' }}
            />
            Add Location
          </div>
        )}
      </FormGroup>
      {!boxesLocation && (
        <AddLocationModal
          formData={formData}
          isOpen={addLocationModal}
          onCancel={locationModal}
          onConfirm={addNewLocation}
        />
      )}
    </>
  );
};

export default LocationDetails;
